export const FETCH_TAB_CELLS_SUCCESS = 'fetchTabCellsSuccess';
export const UPDATE_ACTIVE_SORT_FIELD_TAB_CELLS_M = 'updateActiveSortFieldTabCellsMutation';
export const UPDATE_SEARCH_TAB_CELLS_M = 'updateSearchTabCellsMutation';
export const CLEAR_SEARCH_TAB_CELLS_M = 'clearSearchTabCellsMutation';
